module.exports = __webpack_public_path__ + "img/size1.f14ebc38.png";